import { Component, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PDFExportComponent } from '@progress/kendo-angular-pdf-export';
import { Keys } from 'app/models/core/dropdowns';
import { ISearchLabs, ISearchLabsParameters } from 'app/models/searchLabs/searchLabs';
import { SettingsService } from 'app/services/core/settings.service';
import { SearchLabsService } from 'app/services/searchLabs/searchLabs.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LabApplicationMenuService } from 'app/services/application-menu/lab-application-menu.service';
import { SharedService } from '@shared/services/shared.service';
import { IApplicationTechnologyReport, IApplicationTechnologyViewModel, IInspectionActionsViewModel, IInspectionSummaryViewModel } from 'app/models/reports/reports';
import { InspectionService } from 'app/services/inspection/inspection.service';
import { drawDOM, exportPDF } from '@progress/kendo-drawing';

@Component({
  selector: 'inspectionSummaryReport',
  templateUrl: './inspectionSummaryReport.component.html',
  styleUrls: ['./inspectionSummaryReport.component.scss']
})
export class InspectionSummaryReportComponent {
  
  @ViewChild('pdf') pdf: PDFExportComponent;

  public inspectionData: IInspectionSummaryViewModel = {
    labName: '',
    orelapId: '',
    actions: [],
    assessmentType: '',
    assessmentDate: '',
    summary: '',
    inspectors: []
  };

  public correctiveActions: IInspectionActionsViewModel[][] = [];

  public groupedCorrectiveActions: {
    header: string, count: number, technologies:
      { tech: string, actions: IInspectionActionsViewModel[] }[]
  }[] = [];

  constructor(public searchLabsService: SearchLabsService,
    public settings: SettingsService,
    private dialogRef: MatDialogRef<InspectionSummaryReportComponent>,
    private labApplicationMenuService: LabApplicationMenuService,
    private inspectionService: InspectionService,
    private sharedService: SharedService
  ) {
    console.log('inspection report for application', this.sharedService.currentApplication);
    this.inspectionService.getInspectionSummary(this.sharedService.currentApplication.labApplicationId, this.sharedService.currentLabId).subscribe(
      response => {
        console.log('inspection report response', response);
        this.inspectionData = response;
        this.correctiveActions = response.actions;
        this.groupTechnologies(response.actions);
      },
      error => console.log('error', error)
    );
  }

  groupTechnologies(actions: IInspectionActionsViewModel[][]): void {
    // actions is a 2D array where each inner array has items with the same header
    this.groupedCorrectiveActions = actions.map(actionGroup => {
      if (actionGroup.length === 0) {
        return { header: '', count: 0, technologies: [] };
      }

      // Get the header from the first item (all items in group have same header)
      const header = actionGroup[0].header;
      const count = actionGroup.length;

      // Group by technology within this header group
      const byTechnology: { [key: string]: IInspectionActionsViewModel[] } = {};

      actionGroup.forEach(action => {
        if (!byTechnology[action.technology]) {
          byTechnology[action.technology] = [];
        }
        byTechnology[action.technology].push(action);
      });

      return {
        header: header,
        count: count,
        technologies: Object.keys(byTechnology).map(tech => ({
          tech: tech,
          actions: byTechnology[tech]
        }))
      };
    });
  }

  ngOnInit(): void {
  }

  printReport(): void {
    if (this.pdf) {
      this.pdf.saveAs('ORELAP_Inspection_Summary_Report.pdf');
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  // saveSnapshotAndUpload(): void {
  //   const dialogRef = this.dialog.open(TrainingProgramSnapshotDialog, {
  //     data: { curriculumPageKey: this.curriculumPageKey, trainingProgram: this.trainingProgram, curriculumMap: this.curriculumMap },
  //     width: '800px',
  //     height: 'auto',
  //     position: { top: '-9999px', left: '-9999px' },
  //     autoFocus: false,
  //     panelClass: 'hidden-dialog'
  //   });

  //   dialogRef.afterOpened().subscribe(async () => {
  //     const dialogContent = document.querySelector('#snapshotPdf') as HTMLElement;

  //     const drawOptions = {
  //       scale: 0.75,
  //       paperSize: 'a4',
  //       forcePageBreak: '.page-break',
  //       margin: { top: '1cm', left: '1cm', right: '1cm', bottom: '1cm' }
  //     };

  //     const group = await drawDOM(dialogContent, drawOptions);

  //     const pdfDataUri: string = await exportPDF(group, drawOptions);

  //     const pdfBlob = this.dataUriToBlob(pdfDataUri);

  //     const filename = `TrainingProgramSnapshot-${this.trainingProgram.programId}.pdf`;
  //     const file = new File([pdfBlob], filename, { type: 'application/pdf' });

  //     const upload: IDocument = {
  //       id: 0,
  //       name: file.name,
  //       comments: '',
  //       extenstion: 'pdf',
  //       dateCreated: '',
  //       dateLastUpdated: '',
  //       createdBy: '',
  //       lastUpdatedBy: '',
  //       parentId: this.trainingProgram.id,
  //       types: [this.licenseSnapshotType],
  //       adminOnly: true,
  //       deprecated: false
  //     };

  //     const formData = new FormData();
  //     formData.append('file', file, file.name);
  //     formData.append('document', JSON.stringify(upload));

  //     this.trainingProgramService.uploadTrainingProgramDocument(formData).subscribe({
  //       next: (response) => {
  //         this.trainingProgram.trainingProgramDocuments.push(response);
  //       },
  //       error: (err) => {
  //         console.error('Upload failed', err);
  //       },
  //       complete: () => {
  //         dialogRef.close();
  //       }
  //     });
  //   });
  // }

}

